<div class="container iran-sans" data-aos="fade-up">

    <div class="section-title">
      <h2>مجوز و تاییدیه ها</h2>
      <p>ما تایید شده هستیم</p>
    </div>

    <div class="clients-slider swiper" data-aos="fade-up" data-aos-delay="100">
      <div class="swiper-wrapper align-items-center">
        <div class="swiper-slide"><img src="assets/img/certificates/logo-behdasht.png" class="img-fluid" alt=""></div>
        <div class="swiper-slide"><img src="assets/img/certificates/logo-afta.png" class="img-fluid" alt=""></div>
        <div class="swiper-slide"><img src="assets/img/certificates/logo-tamin.png" class="img-fluid" alt=""></div>
        <div class="swiper-slide"><img src="assets/img/certificates/logo-salamat.png" class="img-fluid" alt=""></div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

  </div>